import React from "react";
import MainSectionLayout from "../../layout/MainSectionLayout";
import FormTemp from "./FormTemp";
import AddReport from "./AddReport";

const IndicatorForm = () => {
    return (
        <MainSectionLayout id="IndicatorForm" style={{ overflowY: "auto", maxHeight: "100vh", display: "flex", flexDirection: "column" }}>
            <AddReport report={true} />
        </MainSectionLayout>
    );
};

export default IndicatorForm;